import React from 'react'
import { Alert, AlertTitle, Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { usePausedOrg } from '@/utils/hooks/usePausedOrg'

/**
 * Banner displayed when the org's subscription is paused.
 * Shows pause status and resume date, with a link to the account page.
 */
export default function PausedBanner() {
  const {
    isPaused,
    isCancelled,
    canWrite,
    formattedResumeDate,
    isPayerChild,
    parentOrgName,
    isLoading,
  } = usePausedOrg()
  const navigate = useNavigate()

  // Don't show while loading or if the org can write
  if (isLoading || canWrite) {
    return null
  }

  return (
    <Box sx={{ mx: { xs: 2, sm: 4, md: 6 }, mb: 2 }}>
      <Alert
        severity="warning"
        action={
          !isPayerChild ? (
          <Button
            variant="outlined"
            size="small"
            disableRipple
            onClick={() => navigate('/account')}
            sx={{ backgroundColor: 'white' }}
          >
            Manage Subscription
          </Button>
          ) : undefined
        }
      >
        <AlertTitle>
          {isCancelled ? 'Account Cancelled' : 'Account Paused'}
        </AlertTitle>
        {isCancelled
          ? 'Your subscription has been cancelled and the app is in read-only mode.'
          : 'Your subscription is paused and the app is in read-only mode.'}
        {isPaused && formattedResumeDate && (
          <> It will automatically resume on {formattedResumeDate}.</>
        )}
        {isPayerChild && (
          <>
            {' '}
            Billing is managed by {parentOrgName || 'the parent organisation'}.
          </>
        )}
      </Alert>
    </Box>
  )
}
